export default __webpack_public_path__ + "static/media/party.b7145b94.mp4";